import { render } from "./StudyItem.vue?vue&type=template&id=60999e66&scoped=true"
import script from "./StudyItem.vue?vue&type=script&lang=js"
export * from "./StudyItem.vue?vue&type=script&lang=js"

import "./StudyItem.vue?vue&type=style&index=0&id=60999e66&lang=scss&scoped=true"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60999e66"]])

export default __exports__